import { render } from "./ClientIncome.vue?vue&type=template&id=3fc7f7ac"
import script from "./ClientIncome.vue?vue&type=script&lang=js"
export * from "./ClientIncome.vue?vue&type=script&lang=js"

import "./ClientIncome.vue?vue&type=style&index=0&id=3fc7f7ac&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__